import script from "./PlotlyGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlotlyGraph.vue?vue&type=script&setup=true&lang=ts"

import "./PlotlyGraph.vue?vue&type=style&index=0&id=272bbaf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272bbaf0"]])

export default __exports__